import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ToastComponent } from '../../shared/toast/toast.component';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ColumnNamePipe } from '../../../pipes/column-name.pipe';
import { MonthNamePipe } from '../../../pipes/month-name.pipe';
import { CustomersService } from '../../../core/services/customer/customers.service';
import { UsersService } from '../../../core/services/user/users.service';
export interface TableData {
  [key: string]: string | number | Date;
}

export interface FilterModel {
  customerCode: string;
  year: number | null;
  month: number | null;
  doctor: string;
}
@Component({
  selector: 'app-tables',
  standalone: true,
  imports: [
    DatePipe,
    CommonModule,
    FormsModule,
    ToastComponent,
    ColumnNamePipe,
    MonthNamePipe,
  ],
  templateUrl: './tables.component.html',
  styleUrl: './tables.component.scss',
  providers: [DatePipe, ColumnNamePipe],
})
export class TablesComponent implements OnInit {
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;
  @Input() data: TableData[] = [];
  @Input() columns: string[] = [];
  @Input() filters: string[] = [];
  @Input() tableHeader: string = '';
  @Output() onChangeFilterValues = new EventEmitter<FilterModel>();
  @Output() onChangePage = new EventEmitter<{
    page: number;
    pageSize: number;
  }>();

  @Input() totalCount: number = 0;
  @Input() totalPage: number = 0;

  customerCodes: any = [];
  expertList: any = [];

  pageSizes = [10, 25, 50, 100];
  pageSize: number = 10;
  currentPage: number = 1;

  maxDate: string;
  filterForm = {
    customerCode: '',
    year: null as number | null,
    month: null as number | null,
    doctor: '',
  };
  months = [
    { value: 1, name: 'January' },
    { value: 2, name: 'February' },
    { value: 3, name: 'March' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    { value: 7, name: 'July' },
    { value: 8, name: 'August' },
    { value: 9, name: 'September' },
    { value: 10, name: 'October' },
    { value: 11, name: 'November' },
    { value: 12, name: 'December' },
  ];
  currentYear = new Date().getFullYear();
  minYear = this.currentYear - 5;
  maxYear = this.currentYear + 5;

  constructor(
    private customersService: CustomersService,
    private usersService: UsersService
  ) {
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];
  }
  ngOnInit(): void {
    if (this.filters.includes('customerCode')) {
      this.getCustomerCodes();
    }

    if (this.filters.includes('doctor')) {
      this.getExpertList();
    }
  }

  getCustomerCodes() {
    this.customersService.allCustomerCodes().subscribe({
      next: (res) => {
        this.customerCodes = res;
      },
      error: () => {},
    });
  }

  getExpertList() {
    this.usersService.getExpertListByBackOffice().subscribe({
      next: (res) => {
        this.expertList = res;
      },
      error: () => {},
    });
  }

  hasFilter(column: string): boolean {
    return this.filters.includes(column);
  }

  clearFilters(): void {
    this.filterForm.customerCode = '';
    this.filterForm.doctor = '';
    this.filterForm.year = null;
    this.filterForm.month = null;

    const filterValues = { ...this.filterForm };
    this.onChangeFilterValues.emit(filterValues);
  }

  filterList(e: Event) {
    e.preventDefault();
    const filterValues = { ...this.filterForm };
    this.onChangeFilterValues.emit(filterValues);
    // this.getUserList(1, this.pageSize, this.filterForm);
  }

  changePageSize(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const size = Number(selectElement.value);
    this.pageSize = size;
    this.currentPage = 1;
    this.onChangePage.emit({ page: this.currentPage, pageSize: this.pageSize });
  }
  changePage(page: number): void {
    if (page > 0 && page <= this.totalPage) {
      this.currentPage = page;
      this.onChangePage.emit({
        page: this.currentPage,
        pageSize: this.pageSize,
      });
    }
  }

  getYears(): number[] {
    const years = [];
    for (let year = this.minYear; year <= this.maxYear; year++) {
      years.push(year);
    }
    return years;
  }

  getTotalForLastColumn(): number {
    const lastColumnKey = this.columns[this.columns.length - 1];
    return this.data.reduce((total, row) => {
      const value = row[lastColumnKey];
      return total + (typeof value === 'number' ? value : 0);
    }, 0);
  }
}
